module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"cancel_button.label":"Cancelar"},"en":{"cancel_button.label":"Cancel"}}')
  delete Component.options._Ctor
}
